// 相对当前时间的中文短描述：刚刚 / X分钟前 / X小时前 / X天前；超过 7 天显示绝对日期 YYYY-MM-DD。
// now 默认取当前时间，可注入便于测试。
export const formatRelativeTime = (date: Date, now: Date = new Date()): string => {
  const diffSec = Math.floor((now.getTime() - date.getTime()) / 1000)
  if (diffSec < 60) {
    return '刚刚'
  }
  const diffMin = Math.floor(diffSec / 60)
  if (diffMin < 60) {
    return `${diffMin}分钟前`
  }
  const diffHour = Math.floor(diffMin / 60)
  if (diffHour < 24) {
    return `${diffHour}小时前`
  }
  const diffDay = Math.floor(diffHour / 24)
  if (diffDay < 7) {
    return `${diffDay}天前`
  }
  const pad = (n: number): string => String(n).padStart(2, '0')
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`
}
